<template>
  <div>
    <el-row style="margin-bottom: 10px">
      <div style="float: left">
        <el-button size="small" v-show="resetALlSelectBtn_isShow" @click="resetALlSelectBtn()">重置所有筛选</el-button>
        <el-dropdown style="margin-left: 10px">
          <el-button type="success" size="small" :disabled="tableData.length==0">
            启用操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="selection=='' " @click.native="start_check()">启用选中</el-dropdown-item>
            <el-dropdown-item @click.native="start_all()">启用{{ filterlist.grouping_id!=='' ? '该组' : '' }}全部</el-dropdown-item>
            <el-dropdown-item @click.native="start_abnorma()">启用{{ filterlist.grouping_id!=='' ? '该组' : '' }}异常</el-dropdown-item>
            <el-dropdown-item @click.native="start_normal()">启用{{ filterlist.grouping_id!=='' ? '该组' : '' }}正常</el-dropdown-item>
            <el-dropdown-item @click.native="start_unknown()">启用{{ filterlist.grouping_id!=='' ? '该组' : '' }}未知</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown style="margin-left: 10px">
          <el-button type="info" size="small" :disabled="tableData.length==0">
            停用操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="selection=='' " @click.native="stop_check()">停用选中</el-dropdown-item>
            <el-dropdown-item @click.native="stop_all()">停用{{ filterlist.grouping_id!=='' ? '该组' : '' }}全部</el-dropdown-item>
            <el-dropdown-item @click.native="stop_abnormal()">停用{{ filterlist.grouping_id!==''? '该组' : '' }}异常</el-dropdown-item>
            <el-dropdown-item @click.native="stop_normal()">停用{{ filterlist.grouping_id!==''? '该组' : '' }}正常</el-dropdown-item>
            <el-dropdown-item @click.native="stop_unknown()">停用{{ filterlist.grouping_id!==''? '该组' : '' }}未知</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown style="margin-left: 10px">
          <el-button type="danger" size="small" :disabled="tableData.length==0">
            删除操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="selection==''" @click.native="delcheck()">删除选中</el-dropdown-item>
            <el-dropdown-item @click.native="delall()">删除{{ filterlist.grouping_id!==''? '该组' : '' }}全部</el-dropdown-item>
            <el-dropdown-item @click.native="delstop()">删除{{ filterlist.grouping_id!==''? '该组' : '' }}停用</el-dropdown-item>
            <el-dropdown-item @click.native="delstart()">删除{{ filterlist.grouping_id!==''? '该组' : '' }}启用</el-dropdown-item>
            <el-dropdown-item @click.native="delabnormal()">删除{{ filterlist.grouping_id!==''? '该组' : '' }}异常</el-dropdown-item>
            <el-dropdown-item @click.native="delnormal()">删除{{ filterlist.grouping_id!==''? '该组' : '' }}正常</el-dropdown-item>
            <el-dropdown-item @click.native="del_unknown()">删除{{ filterlist.grouping_id!==''? '该组' : '' }}未知</el-dropdown-item>
            <el-dropdown-item @click.native="del_overdue()">删除{{ filterlist.grouping_id!==''? '该组' : '' }}过期</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown style="margin-left: 10px">
          <el-button type="primary" size="small" :disabled="tableData.length==0">
            导出表格<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="exportSelect()" :disabled="selection==''">导出选中</el-dropdown-item>
            <el-dropdown-item @click.native="exportsAll()">导出{{ filterlist.grouping_id!==''? '该组' : '' }}全部</el-dropdown-item>
            <el-dropdown-item @click.native="exportsenable()">导出{{ filterlist.grouping_id!==''? '该组' : '' }}启用</el-dropdown-item>
            <el-dropdown-item @click.native="exportsoutservice()">导出{{ filterlist.grouping_id!==''? '该组' : '' }}停用</el-dropdown-item>
            <el-dropdown-item @click.native="exportsabnormal()">导出{{ filterlist.grouping_id!==''? '该组' : '' }}异常</el-dropdown-item>
            <el-dropdown-item @click.native="exportsnormal()">导出{{ filterlist.grouping_id!==''? '该组' : '' }}正常</el-dropdown-item>
            <el-dropdown-item @click.native="exportunknown()">导出{{ filterlist.grouping_id!==''? '该组' : '' }}未知</el-dropdown-item>
            <el-dropdown-item @click.native="exportoverdue()">导出{{ filterlist.grouping_id!==''? '该组' : '' }}过期</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button :disabled="selection.length == 0" style="margin-left: 10px" type="warning" size="small" @click="editGroupForm.id = selection.split(',');changeGroupShow=true">修改选中分组</el-button>
        <span>
          <span style="font-size: 14px;margin-left: 15px;color: #666666">分组管理：</span>
          <el-select v-model="filterlist.grouping_id" style="margin-left: 10px" size="small" placeholder="请选择归属分组" @change="$refs.table.clearSelection();gettableData()">
            <el-option value="" label="全部"></el-option>
            <el-option :value="0" label="默认分组"></el-option>
            <el-option v-for="item in groupList" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </span>
      </div>
      <div style="float: right">
        <span
          class="nowCan_add">当前还可以添加 {{
            ($store.state.package_purchased_monitor + $store.state.monitor - $store.state.monitored) >= 0 ? ($store.state.package_purchased_monitor + $store.state.monitor - $store.state.monitored) : 0
          }} 个</span>
        <el-button
          :disabled="($store.state.package_purchased_monitor + $store.state.monitor - $store.state.monitored) <=0"
          type="primary" size="small"
          @click="showaddBox()">添加任务
        </el-button>
      </div>
    </el-row>
    <el-table
      @cell-mouse-enter="enter"
      @cell-mouse-leave="leave"
      id="tableout"
      :data="tableData"
      v-loading="loading"
      ref="table"
      empty-text="暂未添加任何任务 "
      @selection-change="changecheck($event)"
      @filter-change="filterTag"
      :row-key="function(row) { return row.id}"
      style="width: 100%">
      <el-table-column
        :reserve-selection="true"
        type="selection">
      </el-table-column>
      <el-table-column prop="qq" width="1">
        <template slot-scope="{row}">
          <el-tooltip popper-class="toolCollapse" placement="top" v-model="row.tooltip" content="点击展开更多信息">
            <span></span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row>
            <el-col :span="12">
              <el-form label-position="left" class="demo-table-expand">
                <el-form-item label="任务编号">
                  <el-tag size="small">{{ props.row.id }}</el-tag>
                </el-form-item>
                <el-form-item label="检测方式">
                  <el-tag size="small">{{ props.row.project }}</el-tag>
                </el-form-item>
                <el-form-item label="目标状态">
                  <el-tag size="small" type="success" :disable-transitions="true" v-if="props.row.urlstate == 1">正常
                  </el-tag>
                  <div v-else-if="props.row.urlstate == 0">
                    <el-tag size="small" type="danger" :disable-transitions="true">异常</el-tag>
                  </div>
                  <el-tag size="small" v-else type="info" :disable-transitions="true">未知</el-tag>
                </el-form-item>
                <el-form-item label="更新时间">
                  <el-tag size="small">{{ props.row.update_time }}</el-tag>
                </el-form-item>
                <el-form-item label="自动停用">
                  <el-tag size="small" :type="props.row.switch ? 'success' : 'danger'">
                    {{ props.row.switch ? '已开启' : '已关闭' }}
                  </el-tag>
                </el-form-item>
                <el-form-item label="监控节点">
                  <el-tag size="small">{{ props.row.node }}</el-tag>
                </el-form-item>
                <el-form-item label="是否开启报警复查">
                  <el-tag size="small" :type="props.row.review_switch == 1 ? 'success' : 'danger'">
                    {{ props.row.review_switch ? '是' : '否' }}
                  </el-tag>
                </el-form-item>
                <el-form-item label="通知方式">
                  <el-tag type="info" size="small" v-if="!props.row.tongzhiswitch">未开启</el-tag>
                  <el-tag v-else size="small">
                    <span v-if="props.row.tongzhitype==1">邮件</span>
                    <span v-else-if="props.row.tongzhitype==2">短信</span>
                    <span v-else-if="props.row.tongzhitype==3">电话</span>
                    <span v-else-if="props.row.tongzhitype==4">微信</span>
                    <span v-else-if="props.row.tongzhitype==5">钉钉</span>
                    <span v-else-if="props.row.tongzhitype==6">电报</span>
                    <span v-else-if="props.row.tongzhitype==7">企业微信</span>
                    <span v-else-if="props.row.tongzhitype==8">飞书</span>
                  </el-tag>
                </el-form-item>
                <el-form-item label="是否开启回调">
                  <el-tag size="small" :type="props.row.callbackurlswitch ==1 ? 'success' : 'danger'">
                    {{ props.row.callbackurlswitch == 1 ? '是' : '否' }}
                  </el-tag>
                </el-form-item>
                <el-form-item label="回调地址">
                  <el-link v-if="props.row.callbackurl" :underline="false" type="primary" :href="props.row.callbackurl">
                    {{ props.row.callbackurl }}
                  </el-link>
                  <el-tag v-else size="small" type="info">未开启</el-tag>
                </el-form-item>
                <el-form-item label="执行时间段">
                  <el-tag v-if="props.row.timeswitch == 1" size="small" type="primary">
                    {{JSON.parse(props.row.section_time)[0] | dateFormat}} 至 {{JSON.parse(props.row.section_time)[1] | dateFormat}}
                  </el-tag>
                  <el-tag v-else size="small" type="info">未开启</el-tag>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form label-position="left" class="demo-table-expand">
                <el-form-item label="任务名称">
                  <el-tag size="small">{{ props.row.name }}</el-tag>
                </el-form-item>
                <el-form-item label="监控目标">
                  <el-link :underline="false" type="primary" target="_blank">{{ props.row.url }}</el-link>
                </el-form-item>
                <el-form-item label="具体原因">
                  <el-tag v-if="props.row.urlstate == 0" size="small" type="danger">
                    {{ props.row.urlstatemsg }}
                  </el-tag>
                  <el-tag v-else size="small">无</el-tag>
                </el-form-item>
                <el-form-item label="任务状态">
                  <el-tag size="small" :type="props.row.stateswitch ? 'success' : 'danger'">
                    {{ props.row.stateswitch ? '已开启' : '已停用' }}
                  </el-tag>
                </el-form-item>
                <el-form-item label="告警方式">
                  <el-tag type="primary" size="small">{{ props.row.tongzhistate == 1 ? '异常告警' : '正常告警' }}</el-tag>
                </el-form-item>
                <el-form-item label="是否开启通知">
                  <el-tag size="small" :type="props.row.tongzhiswitch ? 'success' : 'danger'">
                    {{ props.row.tongzhiswitch ? '是' : '否' }}
                  </el-tag>
                </el-form-item>
                <el-form-item  label="报警复查次数">
                  <el-tag size="small" :type="props.row.review_switch == 1 ? 'success' : 'danger'">
                    {{ props.row.review_switch == 1 ? props.row.review_count : "未开启"}}
                  </el-tag>
                </el-form-item>
                <el-form-item label="通知账户">
                  <el-tag size="small" v-if="props.row.mail">
                    <!--邮件电话短信通知账户-->
                    <span v-if="props.row.tongzhitype!=4&&props.row.tongzhitype!=5&&props.row.tongzhitype!=6&&props.row.tongzhitype!=7&&props.row.tongzhitype!=8 ">{{ props.row.mail }}</span>
                    <!--微信通知账户-->
                    <span v-else-if="props.row.tongzhitype==4">
                      <span v-for="item in $store.state.notice_wechat">
                        <span v-if="item.open_id==props.row.mail">{{ item.nickname }}</span>
                      </span>
                    </span>
                    <!--短信通知账户-->
                    <span v-else-if="props.row.tongzhitype==5">
                      <span v-for="item in $store.state.notice_dingtalk">
                        <span v-if="item.id==props.row.mail">{{ item.name }}</span>
                      </span>
                    </span>
                    <span v-else-if="props.row.tongzhitype==6">
                      <span v-for="item in $store.state.notice_telegram">
                        <span v-if="item.chat_id ==props.row.mail">
                          {{item.type=='group' || item.type=='supergroup' ? '群聊' : '个人'}}：{{item.type=='group' || item.type=='supergroup'?item.name:item.username}}
                        </span>
                      </span>
                    </span>
                    <span v-else-if="props.row.tongzhitype==7">
                      <span v-for="item in $store.state.notice_enterprisewechat">
                        <span v-if="item.id == props.row.mail">{{ item.name }}</span>
                      </span>
                    </span>
                    <span v-else-if="props.row.tongzhitype==8">
                      <span v-for="item in $store.state.notice_feishu">
                        <span v-if="item.id == props.row.mail">{{ item.name }}</span>
                      </span>
                    </span>
                  </el-tag>
                  <el-tag v-else size="small" type="info">未开启</el-tag>
                </el-form-item>
                <el-form-item label="回调方式">
                  <div v-if="props.row.callbackurlswitch ==1">
                    <el-tag v-if="props.row.callbackurl_type == 1" size="small" type="primary">POST</el-tag>
                    <el-tag v-else size="small" type="primary">GET</el-tag>
                  </div>
                  <el-tag v-else size="small" type="info">未开启</el-tag>
                </el-form-item>
                <el-form-item label="是否开启时间段执行">
                  <el-tag v-if="props.row.timeswitch == 1" size="small" type="success">已开启</el-tag>
                  <el-tag v-else size="small" type="info">未开启</el-tag>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <!--        </el-row>-->
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="任务名"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="grouping_id"
        label="分组名称">
        <template slot="default" slot-scope="{row}">
          {{ groupList.find(item=>item.id == row.grouping_id)?.name || '默认分组'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="project"
        label="方式"
        :filters="apilist"
        column-key="project"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="time"
        :sortable="true"
        min-width="100"
        label="监测频率">
        <template slot-scope="scoped">
          {{ scoped.row.time }}分钟
        </template>
      </el-table-column>
      <el-table-column
        prop="tongzhitype"
        min-width="100"
        label="通知渠道"
        column-key="tongzhitype"
        :filters="[{ text: '短信', value: '2' }, { text: '电话', value: '3' },{ text: '邮件', value: '1' },{ text: '微信', value: '4' },{ text: '钉钉', value: '5' },{ text: '电报', value: '6' },{ text: '企业微信', value: '7' },{ text: '飞书', value: '8' }]">
        <template slot-scope="scoped">
          <svg v-if="scoped.row.tongzhitype!='5' && scoped.row.tongzhitype!='6' && scoped.row.tongzhitype!='7' && scoped.row.tongzhiswitch" class="icon" aria-hidden="true">
            <use v-if="scoped.row.tongzhitype == '4'" xlink:href="#icon-weixin"></use>
            <use v-else-if="scoped.row.tongzhitype == '2'" xlink:href="#icon-xinxiduanxinsixinduihua"></use>
            <use v-else-if="scoped.row.tongzhitype == '1'" xlink:href="#icon-icon-test"></use>
            <use v-else-if="scoped.row.tongzhitype == '3'" xlink:href="#icon-dianhuabeifen"></use>
            <use v-else-if="scoped.row.tongzhitype == '8'" xlink:href="#icon-feishu"></use>
<!--            <use v-else-if="scoped.row.tongzhitype == '7'" xlink:href="#icon-icon-test1"></use>-->
          </svg>
          <svg v-else-if="scoped.row.tongzhiswitch && scoped.row.tongzhitype=='5'" class="icon dingding_icon">
            <use xlink:href="#icon-dingding"></use>
          </svg>
          <svg v-else-if="scoped.row.tongzhiswitch && scoped.row.tongzhitype=='6'" class="icon dingding_icon">
            <use xlink:href="#icon-telegram"></use>
          </svg>
          <svg v-else-if="scoped.row.tongzhiswitch && scoped.row.tongzhitype=='7'" class="icon dingding_icon">
            <use xlink:href="#icon-icon-test1"></use>
          </svg>
          <svg v-else class="icon">
            <use v-if="!scoped.row.tongzhiswitch" xlink:href="#icon-jinyong"></use>
          </svg>
        </template>
      </el-table-column>
      <el-table-column
        prop="urlstate"
        min-width="100"
        column-key="urlstate"
        :filters="[{ text: '正常', value: '1' }, { text: '异常', value: '0' }, { text: '未知', value: '2' }]"
        label="状态">
        <template slot-scope="scoped">
          <el-tag type="success" :disable-transitions="true" v-if="scoped.row.urlstate == 1">正常</el-tag>
          <el-tooltip v-else-if="scoped.row.urlstate == 0" effect="dark" :content="scoped.row.urlstatemsg"
                      placement="top">
            <el-tag type="danger" :disable-transitions="true">异常</el-tag>
          </el-tooltip>
          <el-tag v-else type="info" :disable-transitions="true">未知</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="启用"
        min-width="120"
        column-key="stateswitch"
        :filters="[{ text: '已启用', value: '1' }, { text: '未启用', value: '0' }]">
        <template slot-scope="scoped">
          <el-switch @change="change_stateswitch(scoped.row.id)" v-model="scoped.row.stateswitch == 1"
                     active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        min-width="140"
        column-key="switch"
        :filters="[{ text: '已启用', value: 1 }, { text: '未启用', value: 0 }]">
        <template slot="header">
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">若开启本功能，根据您设置的告警模式，被监控目标状态发生变化，通知或回调后自动关闭任务，从而避免多次重复提醒，节省账号检测点。（建议不要关闭此功能）
            </div>
            <span>自动停用 <i class="el-icon-question"></i></span>
          </el-tooltip>
        </template>
        <template slot-scope="scoped">
          <el-switch :value="scoped.row.switch == 1" active-color="#13ce66" inactive-color="#ccc"
                     @change="change_switch(scoped.row.id)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300" label-class-name="inputC">
        <template slot="header" slot-scope="scope">
          <el-input style="width: 285px" v-model.trim="search" size="mini" @change="searchName(scope.row)"
                    placeholder="请输入任务名、任务编号或监控目标，回车搜索"/>
        </template>
        <template slot-scope="scoped">
          <div style="text-align: center">
            <el-button type="success" size="small" @click="testCould(scoped.row)" :loading="scoped.row.loading" plain>
              测试
            </el-button>
            <el-button type="primary" icon="el-icon-edit" size="small" plain @click="editshow(scoped.row)"></el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" plain
                       @click="delrow(scoped.row.id)"></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <div style="text-align: center;margin-top: 40px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[5, 20, 50, 100]"
        :page-size="pagesize"
        :current-page="page"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog :visible="changeGroupShow" title="修改分组" @close="changeGroupShow = false;editGroupForm.id = []">
      <el-form>
        <el-alert type="success" :closable="false" style="margin-bottom: 10px">请选择你要将选中的任务转移的新分组</el-alert>
        <el-form-item label="新分组">
          <el-select v-model="editGroupForm.grouping_id">
            <el-option :value="0" label="默认分组"></el-option>
            <el-option v-for="item in groupList" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="changeGroupShow = false;editGroupForm.grouping_id = 0">取消</el-button>
        <el-button type="primary" @click="handleGroupChangeSubmit">确认</el-button>
      </template>
    </el-dialog>
    <addTask v-if="dialogVisible" @addsuccess="addsucess($event)" @closeView="closeView($event)" :father_page="page" :groupList="groupList"
             :father_pagesize="pagesize" :show="dialogVisible" :grouping_id="filterlist.grouping_id"></addTask>
    <editTask @editsuccess="editsuccess($event)" :father_page="page" :father_pagesize="pagesize" v-if="editTask_box" :groupList="groupList"
              @closeEdit="closeEdit($event)" :rowData="editRow" :show="editTask_box"></editTask>
  </div>
</template>
<script>
import '@/../public/iconfont/iconfont'
import '@/../public/iconfont/iconfont1'
import addTask from './AddTask'
import editTask from './EditTask'

export default {
  components: {
    addTask,
    editTask
  },
  data () {
    return {
      changeGroupShow:false,
      fanxuan_ishow: false,
      resetALlSelectBtn_isShow: false,
      apilist: [],
      loading: true,
      page: 1,
      tableData: [],
      search: '',
      dialogVisible: false,
      pagesize: 5,
      total: 0,
      selection: '',
      filterlist: {
        project: '',
        stateswitch: '',
        switch: '',
        tongzhitype: '',
        urlstate: '',
        grouping_id:''
      },
      groupList:[],
      editTask_box: false,
      editRow: {},
      editGroupForm:{
        id:[],
        grouping_id:0
      },
    }
  },
  created () {
    this.getGroupList()
    this.gettableData()
    this.$store.state.apilist.forEach(item => {
      this.apilist.push({
        text: item.name,
        value: item.interface_name
      })
    })
  },
  methods: {
    handleGroupChangeSubmit(){
      this.$http.post('/task/grouping/task_edit',this.editGroupForm).then(({data})=>{
        if(data.status == 'success'){
          this.$message.success('修改成功')
          this.gettableData()
          this.changeGroupShow = false
          this.editGroupForm.grouping_id = 0
          this.$refs.table.clearSelection()
        }else{
          this.$message.error(data.msg)
        }
      })
    },
    getGroupList(){
      this.$http.get('/task/grouping/list').then(({data})=>{
        if(data.status == 'success'){
          this.groupList = data.data
        }
      })
    },
    //获取数据
    async gettableData () {
      try {
        this.loading = true
        const { data } = await this.$http.post('/task/tasklist/', {
          page: this.page,
          eachpage: this.pagesize,
          screen: 1,
          type: this.filterlist.project,
          switch: this.filterlist.stateswitch,
          exception: this.filterlist.switch,
          notice: this.filterlist.tongzhitype,
          status: this.filterlist.urlstate,
          search: this.search,
          grouping_id: this.filterlist.grouping_id,
        })
        if (data.status == 'success') {
          data.data.data.forEach(item => {
            item.tooltip = false
            item.loading = false
          })
          this.tableData = data.data.data
          this.total = data.data.total
          this.loading = false
        } else {
          this.loading = true
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.loading = true
        this.$message.error('网络异常，请稍后重试')
      }
    },

    // 测试任务
    async testCould (row) {
      var index = this.tableData.findIndex(item => {
        return item.id == row.id
      })
      this.tableData[index].loading = true
      try {
        const { data } = await this.$http.post('/cloudtask', { id: row.id }, { timeout: 10000 })
        if (data.status == 'success') {
          this.tableData.forEach(item => {
            if (item.id == row.id) {
              item.urlstate = data.data.state
              item.urlstatemsg = data.data.msg
              item.stateswitch = data.data.stateswitch
              item.update_time = data.data.update_time
            }
          })
          this.$message.success('测试成功')
        } else {
          this.$message.error(data.msg)
        }
        this.tableData[index].loading = false
      } catch (e) {
        this.tableData[index].loading = false
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //导出正常
    exportsnormal () {
      window.open(`//api.user.urlzt.com/api/task/execl?islogin=${localStorage.getItem('ticket')}&type=normal&grouping_id=${this.filterlist.grouping_id}`)
    },
    //导出异常
    exportsabnormal () {
      window.open(`//api.user.urlzt.com/api/task/execl?islogin=${localStorage.getItem('ticket')}&type=abnormal&grouping_id=${this.filterlist.grouping_id}`)
    },
    //导出停用
    exportsoutservice () {
      window.open(`//api.user.urlzt.com/api/task/execl?islogin=${localStorage.getItem('ticket')}&type=outservice&grouping_id=${this.filterlist.grouping_id}`)
    },
    //导出启用
    exportsenable () {
      window.open(`//api.user.urlzt.com/api/task/execl?islogin=${localStorage.getItem('ticket')}&type=enable&grouping_id=${this.filterlist.grouping_id}`)
    },
    //导出选中
    exportSelect () {
      window.open(`//api.user.urlzt.com/api/task/execl?id=${this.selection}&islogin=${localStorage.getItem('ticket')}&type=select&grouping_id=${this.filterlist.grouping_id}`)
    },
    //导出未知
    exportunknown () {
      window.open(`//api.user.urlzt.com/api/task/execl?id=${this.selection}&islogin=${localStorage.getItem('ticket')}&type=unknown&grouping_id=${this.filterlist.grouping_id}`)
    },
    //导出过期
    exportoverdue(){
      window.open(`//api.user.urlzt.com/api/task/execl?id=${this.selection}&islogin=${localStorage.getItem('ticket')}&type=overdue&grouping_id=${this.filterlist.grouping_id}`)
    },
    //导出全部
    exportsAll () {
      window.open(`//api.user.urlzt.com/api/task/execl?islogin=${localStorage.getItem('ticket')}&type=all&grouping_id=${this.filterlist.grouping_id}`)
    },
    //停用正常
    async stop_normal () {
      try {
        const { data } = await this.$http.post('/task/stopnormal',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.$message.success('停用正常成功')
          this.tableData.forEach(item => {
            if (item.urlstate == 1) {
              item.stateswitch = 0
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //停用异常方法
    async stop_abnormal () {
      try {
        const { data } = await this.$http.post('/task/stopabnormal',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.$message.success('停用异常成功')
          this.tableData.forEach(item => {
            if (item.urlstate == 0) {
              item.stateswitch = 0
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //停用未知
    async stop_unknown () {
      try {
        const { data } = await this.$http.post('/task/stop_unknown',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.$message.success('停用未知成功')
          this.tableData.forEach(item => {
            if (item.urlstate == 2) {
              item.stateswitch = 0
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //停用全部
    async stop_all () {
      try {
        const { data } = await this.$http.post('/task/allstop',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.$message.success('停用全部成功')
          this.tableData.forEach(item => {
            item.stateswitch = 0
          })
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //启动正常
    async start_normal () {
      try {
        const { data } = await this.$http.post('/task/startnormal',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.$message.success('启用正常成功')
          this.tableData.forEach(item => {
            if (item.urlstate == 1) {
              item.stateswitch = 1
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //启动异常方法
    async start_abnorma () {
      try {
        const { data } = await this.$http.post('/task/startabnormal',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.$message.success('启用异常成功')
          this.tableData.forEach(item => {
            if (item.urlstate == 0) {
              item.stateswitch = 1
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //启动全部方法
    async start_all () {
      try {
        const { data } = await this.$http.post('/task/allstart',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.$message.success('启用全部成功')
          this.tableData.forEach(item => {
            item.stateswitch = 1
          })
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //启用未知
    async start_unknown () {
      try {
        const { data } = await this.$http.post('/task/start_unknown',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.$message.success('启用未知成功')
          this.tableData.forEach(item => {
            if (item.urlstate == 2) {
              item.stateswitch = 1
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //删除过期
    del_overdue(){
      this.$confirm('您确认并要删除所有已过期的任务吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(async () => {
        const { data } = await this.$http.post('/task/del_overdue', {
          page: this.page,
          eachpage: this.pagesize,
          grouping_id:this.filterlist.grouping_id
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })

          this.selection = ''
          this.$refs.table.clearSelection()
          this.tableData = data.data
          this.total = data.total
          //当前页的计算
          if(this.total != 0){
            var page = parseInt(this.total / this.pagesize)== 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          }else {
            this.page = 1
          }
          this.$message.success('删除过期成功')
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //删除异常
    delabnormal () {
      this.$confirm('您确认并要删除所有状态异常的任务吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(async () => {
        const { data } = await this.$http.post('/task/delabnormal', {
          page: this.page,
          eachpage: this.pagesize,
          grouping_id:this.filterlist.grouping_id
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          this.selection = ''
          this.$refs.table.clearSelection()
          //当前页的计算
          if(this.total != 0){
            var page = parseInt(this.total / this.pagesize)== 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          }else {
            this.page = 1
          }
          this.$message.success('删除异常成功')
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //删除正常
    delnormal () {
      this.$confirm('您确认并要删除所有状态正常的任务吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(async () => {
        const { data } = await this.$http.post('/task/delnormal', {
          page: this.page,
          eachpage: this.pagesize,
          grouping_id:this.filterlist.grouping_id
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          this.selection = ''
          this.$refs.table.clearSelection()
          //当前页的计算
          if(this.total != 0){
            var page = parseInt(this.total / this.pagesize)== 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          }else {
            this.page = 1
          }
          this.$message.success('删除正常成功')
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //删除未知
    del_unknown () {
      this.$confirm('您确认并要删除所有状态未知的任务吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(async () => {
        const { data } = await this.$http.post('/task/del_unknown', {
          page: this.page,
          eachpage: this.pagesize,
          grouping_id:this.filterlist.grouping_id
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          this.selection = ''
          this.$refs.table.clearSelection()
          //当前页的计算
          if(this.total != 0){
            var page = parseInt(this.total / this.pagesize)== 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          }else {
            this.page = 1
          }
          this.$message.success('删除未知成功')
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    closeEdit (bool) {
      this.editTask_box = bool
    },
    //修改任务
    editshow (row) {
      this.editRow = row
      this.editTask_box = true
    },
    // 修改成功更新视图
    editsuccess (data) {
      data.data.forEach(item => {
        item.loading = false
      })
      this.filterlist.grouping_id = data.grouping_id
      this.tableData = data.data
      this.total = data.total
    },
    //添加成功更新视图
    addsucess (data) {
      data.data.forEach(item => {
        item.loading = false
      })
      this.filterlist.grouping_id = data.grouping_id
      this.tableData = data.data
      this.total = data.total
      this.$store.commit('setOther', {
        name: 'monitored',
        value: data.total
      }) //修改仓库中已用任务额度
    },
    //删除启用
    delstart () {
      this.$confirm('您确认并要删除所有已启用的任务吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(async () => {
        const { data } = await this.$http.post('/task/delstart', {
          page: this.page,
          eachpage: this.pagesize,
          grouping_id:this.filterlist.grouping_id
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          //当前页的计算
          if(this.total != 0){
            var page = parseInt(this.total / this.pagesize)== 0 ? 1 : parseInt(this.total / this.pagesize)
            this.page = page
          }else {
            this.page = 1
          }
          this.$message.success('删除启用成功')
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //删除停用
    delstop () {
      this.$confirm('您确认并要删除所有已停用的任务吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(async () => {
        const { data } = await this.$http.post('/task/delstop', {
          page: this.page,
          eachpage: this.pagesize,
          grouping_id:this.filterlist.grouping_id
        })
        if (data.status == 'success') {
          data.data.forEach(item => {
            item.loading = false
          })
          this.tableData = data.data
          this.total = data.total
          this.selection = ''
          this.$refs.table.clearSelection()
          //当前页的计算
          if(this.total != 0){
            var page = parseInt(this.total / this.pagesize)
            this.page = page
          }else {
            this.page = 1
          }
          this.$message.success('删除停用成功')
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //停用的公共方法
    async stop (idlist) {
      try {
        const { data } = await this.$http.post('/task/selectstop', { id: idlist,grouping_id:this.filterlist.grouping_id })
        if (data.status == 'success') {
          let arr = idlist.split(',')
          arr.forEach(item1 => {
            let index = this.tableData.findIndex(item => {
              return item.id == item1
            })
            this.tableData[index].stateswitch = 0
          })
          this.$refs.table.clearSelection()
          this.$message.success(data.msg)
        } else {
          this.$refs.table.clearSelection()
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    //停用选中
    stop_check () {
      this.stop(this.selection)
    },
    // 启动的公共方法
    async start (idlist) {
      try {
        const { data } = await this.$http.post('/task/selectstart', { id: idlist,grouping_id:this.filterlist.grouping_id })
        if (data.status == 'success') {
          let arr = idlist.split(',')
          arr.forEach(item1 => {
            let index = this.tableData.findIndex(item => {
              return item.id == item1
            })
            this.tableData[index].stateswitch = 1
          })
          this.$refs.table.clearSelection()
          this.$message.success(data.msg)
        } else {
          this.$refs.table.clearSelection()
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.$message.error('网络异常，请稍后重试')
      }
    },
    // 启动选中
    async start_check () {
      this.start(this.selection)
    },
    // 更改自动停用状态
    change_switch (id) {
      this.tableData.forEach(async (item, index) => {
        if (item.id == id) {
          if (this.tableData[index].switch == 1) {
            const { data } = await this.$http.post('/task/abnormalstop', { id: id })
            if (data.status == 'success') {
              this.$message.success(data.msg)
              this.tableData[index].switch = 0
            } else {
              this.$message.success(data.msg)
            }
          } else {
            const { data } = await this.$http.post('/task/abnormalstart', { id: id })
            if (data.status == 'success') {
              this.$message.success(data.msg)
              this.tableData[index].switch = 1
            } else {
              this.$message.success(data.msg)
            }
          }
        }
      })
    },
    //更改任务开启状态
    change_stateswitch (id) {
      var index = this.tableData.findIndex(item => {
        return id == item.id
      })
      if (this.tableData[index].stateswitch == 0) {
        this.start(id + '')
      } else {
        this.stop(id + '')
      }
    },
    //选中项变化的时候
    changecheck (selection) {
      this.selection = ''
      selection.forEach((item, index) => {
        if (index == selection.length - 1) {
          this.selection = this.selection + item.id
        } else {
          this.selection = this.selection + item.id + ','
        }
      })
    },
    //公共的删除方法
    async delmethod (idlist, page, pagesize) {
      this.loading = true
      const { data } = await this.$http.post('/task/selectdel', {
        id: idlist,
        page: page,
        eachpage: pagesize,
        grouping_id:this.filterlist.grouping_id
      })
      if (data.status == 'success') {
        data.data.forEach(item => {
          item.loading = false
        })
        this.tableData = data.data
        this.total = data.total
        this.selection = ''
        this.$refs.table.clearSelection()
        this.$message.success('删除成功')
        this.$store.commit('setOther', {
          name: 'monitored',
          value: data.total
        }) //修改仓库中已用任务额度
      } else {
        this.$message.error(data.msg)
      }
      this.loading = false
    },
    //删除单个
    async delrow (id) {
      if (this.selection.split(',').length == this.tableData.length) {
        this.page -= 1
      }
      this.delmethod(id, this.page, this.pagesize)
    },
    // 删除选中
    delcheck () {
      if (this.selection == '') {
        return this.$message.error('未选择任何任务')
      }
      this.$confirm('确定要删除选中任务吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        if (this.selection.split(',').length == this.tableData.length) {
          if (this.page > 1) {
            this.page -= 1
          } else {
            this.page = 1
          }
        }
        this.delmethod(this.selection, this.page, this.pagesize)
      })
    },
    //删除全部
    async delall () {
      this.$confirm('确认要删除所有的任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(async () => {
        const { data } = await this.$http.post('/task/delall',{grouping_id:this.filterlist.grouping_id})
        if (data.status == 'success') {
          this.tableData = []
          this.total = 0
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.selection = ''
          this.$refs.table.clearSelection()
          this.$store.commit('setOther', {
            name: 'monitored',
            value: data.total
          }) //修改仓库中已用任务额度
        } else {
          this.$message.error(data.msg)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    //change每页大小
    handleSizeChange (size) {
      this.pagesize = size
      this.page = 1
      this.gettableData()
    },
    //更改页码
    handleCurrentChange (page) {
      this.page = page
      this.gettableData()
    },
    //筛选表格状态
    filterTag (filterObj) {
      this.filterlist[Object.keys(filterObj)[0]] = filterObj[Object.keys(filterObj)[0]].join(',')
      var bool = Object.values(this.filterlist).every(item => {
        return item == ''
      })
      this.resetALlSelectBtn_isShow = !bool
      this.page = 1
      this.gettableData()
    },
    //清空筛选
    resetALlSelectBtn () {
      this.resetALlSelectBtn_isShow = false
      this.$refs.table.clearFilter()
      this.filterlist = {
        project: '',
        stateswitch: '',
        switch: '',
        tongzhitype: '',
        urlstate: '',
        grouping_id: ''
      }
      this.search = ''
      this.page = 1
      this.gettableData()
    },
    //searchName
    searchName (row) {
      this.page = 1
      this.gettableData()
    },
    showaddBox () {
      this.dialogVisible = true
    },
    closeView (bool) {
      this.dialogVisible = bool
    },

    enter (row) {
      row.tooltip = true
    },
    leave (row) {
      row.tooltip = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .demo-table-expand {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  label {
    width: 150px;
    color: #99a9bf;
  }
}

.prop_title {
  font-weight: 600;
  color: #909399;
}

.icon {
  width: 2em;
  height: 2em;
  vertical-align: middle;
  margin-left: 10px;
}

.dingding_icon {
  width: 2.3em;
  height: 2.3em;
}

.nowCan_add {
  color: #ccc;
  font-size: 12px;
  margin-right: 10px;
}

.el-link {
  /deep/ .el-link--inner {
    overflow: hidden;
    max-width: 500px;
    text-overflow: ellipsis;
  }
}

/deep/ .inputC {
  width: unset !important;
}
</style>
